import { render, staticRenderFns } from "./RackAssignment.vue?vue&type=template&id=4ff1ebd0&scoped=true&"
import script from "./RackAssignment.vue?vue&type=script&lang=js&"
export * from "./RackAssignment.vue?vue&type=script&lang=js&"
import style0 from "./RackAssignment.vue?vue&type=style&index=0&id=4ff1ebd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff1ebd0",
  null
  
)

export default component.exports